/* eslint-disable import/prefer-default-export */
// Mapa de documentos por país
const DOCUMENT_MAP = {
  CO: {
    cedula: "CC", // Cédula de ciudadanía
    pasaporte: "CE", // según tu pedido: pasaporte -> CE para CO
    ruc: "NIT",
    nit: "NIT",
    otro: "OTRO"
  },

  CL: {
    cedula: "CI",
    rut: "RUT",
    pasaporte: "PP",
    otro: "OTRO"
  },

  EC: {
    cedula: "CI",
    pasaporte: "PP",
    ruc: "RUC",
    otro: "OTRO"
  }
};

/**
 * DocumentCode
 * @param {string} countryCode - código del país (ej: 'CO', 'EC', 'CL')
 * @param {string} idType - tipo de documento en texto libre (ej: 'cedula', 'pasaporte', 'ruc', 'rut', 'otro')
 * @param {object} [options] - { fallback: string | null } opcional
 * @returns {string|null} - código correspondiente (ej: 'CC', 'PP', 'NIT') o fallback/null
 */

export const getDocumentCode = (countryCode, idType, options = {}) => {
  if (!countryCode || !idType) return options.fallback ?? null;

  const country = String(countryCode).trim().toUpperCase();
  const type = String(idType).trim().toLowerCase();

  const countryMap = DOCUMENT_MAP[country];
  if (!countryMap) return options.fallback ?? null;

  // normalización de sinónimos comunes
  const normalize = {
    cédula: 'cedula',
    cedula: 'cedula',
    'cédula de ciudadanía': 'cedula',
    pasaporte: 'pasaporte',
    ruc: 'ruc',
    nit: 'nit',
    rut: 'rut',
    otro: 'otro',
    'cédula de extranjería': 'cedula' // si quieres mapear distinto, cámbialo
  };

  const normalizedType = normalize[type] || type;

  return countryMap[normalizedType] ?? options.fallback ?? null;
};
